import debounce from 'just-debounce-it'
import {useCallback, useContext, useRef} from 'react'
import {Col, Row, Stack} from 'react-bootstrap'
import Select, {MultiValue, SelectInstance, SingleValue} from 'react-select'
import makeAnimated from 'react-select/animated'
import {useUserInfo} from '../../../../routing/store/InfoUserProvider'
import {TableSearch} from '../../../../shared/TableSearch'
import {PartnerContext} from '../PartnerContexts'

interface IOption {
  value: any
  label: string
}

type SelectChangeValues = SingleValue<IOption | null> | MultiValue<IOption | null>

const animateComponents = makeAnimated()

const PartnersListHeader = () => {
  const {unidadesAdmin} = useUserInfo()
  const {setSearchTerm, setSearchDocument, setSearchUnidad} = useContext(PartnerContext)
  const usersSelectedRef = useRef<SelectInstance<IOption | null>>(null)

  const handleSearch = (value: string) => {
    setSearchTerm(value)
  }
  const handleSearchDocument = (value: string) => {
    setSearchDocument(value)
  }

  const filterByClients = useCallback(
    debounce((unidades: string[]) => {
      console.log('debounce should be call and filter by clients after 500ms', unidades)
      setSearchUnidad(unidades)
    }, 500),
    []
  )

  const onChangeSelect = (selectedOptions: SelectChangeValues) => {
    const unidades = (selectedOptions as IOption[]).map((option) => option?.value)
    filterByClients(unidades)
  }

  const options = unidadesAdmin.map((unidad) => ({value: unidad.id, label: unidad.name}))

  return (
    <>
      <div className='mx-8 mt-8 mb-2'>
        <Row className='mb-4'>
          <Col>
            <Stack direction='vertical' className='h-100'>
              <span className='fw-bold'>Seleccionar Unidad</span>
              <Select
                options={options}
                isMulti
                onChange={onChangeSelect}
                ref={usersSelectedRef}
                components={animateComponents}
                closeMenuOnSelect={false}
                noOptionsMessage={() => 'No hay unidades'}
                placeholder='Seleccionar unidad'
              />
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' className='h-100'>
              <span className='fw-bold'>Buscar Proceso</span>
              <TableSearch
                typeBusqueda='Proceso'
                onSearch={handleSearch}
                design={true}
                className={'same-height'}
              />
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' className='h-100'>
              <span className='fw-bold'>Buscar Documento</span>
              <TableSearch
                typeBusqueda='documento'
                onSearch={handleSearchDocument}
                design={true}
                className={'same-height'}
              />
            </Stack>
          </Col>
        </Row>
      </div>
    </>
  )
}

export {PartnersListHeader}
